import GridIcon from '@atlaskit/icon/core/grid';
import * as React from 'react';

export function SvgGrid() {
  return <GridIcon label="" testId="ads-refreshed-icon" />;
}
